import parsed_played_cards from "../../../types/parsed_played_cards";
import placement_rule from "../../../types/placement_rule";
import played_card from "../../../types/played_card";

let placement_rule_roads_and_rivers: placement_rule = (played_cards: played_card[], parsed_played_cards: parsed_played_cards, played_card: played_card) => {
    return true; //TODO: implement
}

export default placement_rule_roads_and_rivers;